import { Component, input, output, signal } from '@angular/core';
import { TaskResponse } from '../../models/task.model';

@Component({
  selector: 'app-task-complete-dialog',
  imports: [],
  templateUrl: './task-complete-dialog.component.html',
})
export class TaskCompleteDialogComponent {
  visible = input<boolean>(false);
  task = input<TaskResponse>();
  closed = output<void>();
  complete = output<{ taskId: number; notes: string }>();
  notes = signal('');

  close(): void {
    this.notes.set('');
    this.closed.emit();
  }

  confirm(): void {
    const task = this.task();

    if (!task?.id) return;

    this.complete.emit({
      taskId: task.id,
      notes: this.notes(),
    });

    this.notes.set('');
  }

  onNotesChange(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.notes.set(value);
  }
}
